
import $ from "jquery"

const CELL_SELECTOR = ".cell-authentication-box"

const INPUTS_SELECTOR = `${CELL_SELECTOR} .cell-section-auth--sign-up__email-input, ${CELL_SELECTOR} .cell-section-auth--sign-in__email-input`

// unused logic?
const onLoad = () => {
  $("body").on("change keypress paste textInput input", INPUTS_SELECTOR, (e) => {
    const $el_with_change = $(e.currentTarget)
    const latest_value = $el_with_change.val()

    // # This includes `this` and another hidden input
    $(INPUTS_SELECTOR).each((idx, el) => {
      // # The field with input should NOT be update
      const $el = $(el)
      if ($el[0] === $el_with_change[0]) { return }

      $el.val(latest_value)
    })
  })
}

export default {onLoad}
